var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreated1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r5ozxp8v7a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.447 111.198 58.917-34.495 11.455 7.718a.488.488 0 0 1-.02.822l-56.611 34.296a1.464 1.464 0 0 1-1.524-.005l-12.226-7.499a.488.488 0 0 1 .009-.837z",
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.184 50.421c7.194-4.094 14.415-5.06 19.95-1.867l.232.134 1.642.952.715.42.725.431.49.296.747.458.508.316.516.326.793.51.542.355.552.368.565.383.579.398.293.204.598.422.614.44.629.458.645.477.571.428c.169 6.103-4.469 14.544-9.837 22.077l-.546.759-.274.376-.552.749c-.184.248-.369.494-.553.739l-.557.732c-.093.12-.185.242-.278.361l-.557.718-.278.353-.557.701-.277.346-.553.682-.551.67-.273.33-.544.65-.538.634-.533.62-.263.302-.52.595-.257.29-.508.568-.497.55a98.3 98.3 0 0 1-.244.267l-.48.521-.47.501c-7.011 7.443-15.572 15.192-25.68 23.249l-1.328 1.054-.545.429-1.691-.909-1.91-1.039-1.711-.945-.782-.438-.732-.415-.846-.486-.62-.362-.707-.42-.51-.309-.46-.287-.311-.199-.283-.185-.413-.282c-3.06-10.39-.75-24.85 7.133-38.497 5.497-9.516 12.731-16.83 19.987-20.959z",
    fill: "#E5F2F5",
    stroke: "#0E1D31",
    strokeWidth: 0.488
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.938 56.27c7.195-4.094 14.415-5.06 19.95-1.866 4.026 2.323 6.59 6.522 7.709 11.824 1.158 5.491.765 12.164-1.177 19.189l-52.476 30.681c-4.25-9.398-2.24-24.59 6.008-38.868 5.497-9.516 12.73-16.83 19.986-20.96z",
    fill: "#fff",
    stroke: "#0E1D31",
    strokeWidth: 0.488
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.234 3.12C57.722-.001 63.231-.745 67.456 1.693l.516.294.516.288 1.78.98.496.28.491.281c2.12 1.234 4.024 2.581 5.268 4.642.987 1.636 1.556 3.722 1.496 6.55-.108 5.092-2.24 12.557-7.613 24.074-5.108 10.95-9.733 16.666-13.969 19.25-2.454 1.497-4.772 1.933-6.97 1.728-2.901-.27-5.59-1.647-8.105-3.154l-.553-.335-.548-.338-1.615-1.005-.53-.325-.523-.316a41.786 41.786 0 0 0-.52-.305c-4.223-2.437-6.332-7.577-6.37-13.888-.039-6.381 2.043-13.966 6.247-21.243 4.204-7.277 9.736-12.872 15.284-16.03z",
    fill: "#E5F2F5",
    stroke: "#0E1D31",
    strokeWidth: 0.488
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.704 7.6c5.488-3.123 10.997-3.867 15.22-1.43 4.224 2.437 6.333 7.577 6.371 13.888.039 6.38-2.043 13.966-6.247 21.243-4.204 7.277-9.736 12.871-15.284 16.029-5.488 3.123-10.997 3.867-15.22 1.43-4.224-2.437-6.334-7.577-6.372-13.889-.038-6.38 2.044-13.965 6.248-21.243 4.204-7.277 9.735-12.871 15.284-16.029z",
    fill: "#fff",
    stroke: "#0E1D31",
    strokeWidth: 0.488
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.907 50.225c3.82-1.623 7.84-1.668 11.155.27 3.316 1.938 5.288 5.489 5.81 9.651.527 4.198-.42 9.019-2.958 13.47-2.538 4.45-6.187 7.69-10.04 9.327-3.82 1.623-7.84 1.669-11.155-.269-3.316-1.939-5.288-5.489-5.81-9.651-.526-4.198.42-9.019 2.959-13.47 2.537-4.45 6.186-7.69 10.039-9.328z",
    fill: "#66B6C6",
    stroke: "#0E1D31",
    strokeWidth: 0.488
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.519 71.72 5.563 4.033 10.037-16.251",
    stroke: "#fff",
    strokeWidth: 3.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "r5ozxp8v7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(20.744)",
    d: "M0 0h79.512v120H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated1);
export default __webpack_public_path__ + "static/media/created-1.91bafbb5.svg";
export { ForwardRef as ReactComponent };